import { statesList } from './chunk-3YIOW4BW.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/factories/statesDropdownFactory.ts
var statesDropdownFactory = () => {
  const statesArray = Object.values(statesList);
  const statesDropdownOptions = statesArray.map((state, index) => ({
    value: index + 1,
    label: i18n_config_default.t(`states.${state}`)
  }));
  return { states: statesArray, options: statesDropdownOptions };
};

export { statesDropdownFactory };
